// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1abuF","inputDescription":"styles_inputDescription__2m9Zf"};